import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/shared/types/api.types';

const MAX_RETRIES = 2;

/**
 * React Query owns all server-derived state. Retrying is limited to errors where a retry
 * can actually succeed — repeating a 403 or a 404 only delays the error the user needs
 * to see.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: (failureCount, error) => {
          if (failureCount >= MAX_RETRIES) return false;
          return error instanceof ApiError ? error.isRetryable : false;
        },
        // The session is re-validated by the API client, so refetching on every window
        // focus mostly generates noise on a data-heavy dashboard.
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}
